import React from 'react';
import '../styles/DayDetailsModal.css';

function DayDetailsModal({ 
  isOpen, 
  onClose, 
  date, 
  activities, 
  onAddActivity,
  onOpenWorkout 
}) {
  if (!isOpen || !date) return null;

  // Format date for display
  const formatDate = (date) => {
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  // Convert 24-hour time to 12-hour AM/PM format
  const convertTo12Hour = (timeStr) => {
    if (!timeStr) return '';
    
    // If already in 12-hour format (contains AM/PM), return as is
    if (timeStr.includes('AM') || timeStr.includes('PM')) {
      return timeStr;
    }
    
    // Try to parse 24-hour format (HH:mm or HH:mm:ss)
    const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
    if (!timeMatch) return timeStr;
    
    let hours = parseInt(timeMatch[1], 10);
    const minutes = timeMatch[2];
    const period = hours >= 12 ? 'PM' : 'AM';
    
    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }
    
    return `${hours}:${minutes} ${period}`;
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="day-details-modal-overlay" onClick={handleOverlayClick}>
      <div className="day-details-modal">
        {/* Header */}
        <div className="day-details-header">
          <h2 className="day-details-date">{formatDate(date)}</h2>
          <button className="day-details-close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        {/* Activities List */}
        <div className="day-details-content">
          {activities.length > 0 ? (
            <div className="day-details-activities">
              {activities.map((activity, index) => (
                <div 
                  key={index} 
                  className="day-details-activity-card"
                  onClick={() => onOpenWorkout && onOpenWorkout(activity)}
                >
                  <div className="day-details-activity-info">
                    <h3 className="day-details-activity-name">{activity.name}</h3>
                    <div className="day-details-activity-meta">
                      {activity.time && (
                        <span className="day-details-activity-time">
                          {convertTo12Hour(activity.time)}
                        </span>
                      )}
                      {activity.time && activity.duration && (
                        <span className="day-details-activity-divider">·</span>
                      )}
                      {activity.duration && (
                        <span className="day-details-activity-duration">
                          {activity.duration} min
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="day-details-activity-chevron">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="day-details-empty">
              <p>No activities scheduled</p>
            </div>
          )}
        </div>

        {/* Add Activity Button */}
        <div className="day-details-actions">
          <button 
            className="c-ripple day-details-add-btn"
            onClick={onAddActivity}
          >
            <span className="day-details-add-icon">+</span>
            Add Activity
          </button>
        </div>
      </div>
    </div>
  );
}

export default DayDetailsModal;


